import { Calendar, CheckCircle, ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';
import { formatDate } from 'utils/helpers';
import { startCase } from 'lodash';
import StatusBadge from 'components/StatusBadge'
import { appointmentStatusHash } from './helper'

const Item = ({ item }) => {
  const [isHistoryExpanded, setIsHistoryExpanded] = useState(false);

  let { originated_appointment, future_appointment, preferred_days, notes, patient_decision_type,
    preferred_times, patient_schedule_notes, patient_request_type, created_at } = item?.attributes || {}
  let { appointment_at, status } = originated_appointment?.data?.attributes || {}
  let { attributes, id: futureAppointmentId } = future_appointment?.data || {}
  let { appointment_at: fAppointment_at, provider, duration } = attributes || {}
  let { first_name } = provider?.data?.attributes || {}

  return (
    <div className="mt-4 bg-white border border-slate-100 rounded-xl overflow-hidden shadow-sm">
      <div
        onClick={() => setIsHistoryExpanded(!isHistoryExpanded)}
        className="p-4 flex items-center justify-between cursor-pointer hover:bg-slate-50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-slate-50 text-secondary-650 shrink-0">
            <Calendar className="w-4 h-4" />
          </div>
          <div>
            <h4 className="text-xs font-bold text-secondary-900">Visit: {formatDate(appointment_at, 'short')}</h4>
            <p className="text-[9px] text-secondary-500 mt-0.5">From Appointment #apt_{item?.id}</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <StatusBadge
            status={startCase(status)}
            className={appointmentStatusHash[status]}
          />

          {status !== 'declined' &&
            <div className="flex items-center justify-center w-5 h-5 rounded-full bg-green-50 text-green-700 shrink-0">
              <CheckCircle className="w-3 h-3 stroke-[3]" />
            </div>
          }

          {isHistoryExpanded ? (
            <ChevronUp className="w-4 h-4 text-secondary-400" />
          ) : (
            <ChevronDown className="w-4 h-4 text-secondary-400" />
          )}
        </div>
      </div>

      {isHistoryExpanded && (
        <div className="px-4 pb-4 pt-1 space-y-3 border-t border-slate-50">
          <div className="bg-[#eff6ff]/70 border border-blue-100/30 rounded-lg mt-2 p-4 space-y-2">
            <h5 className="text-[10px] font-bold text-blue-600 tracking-wide">Patient Scheduling Preferences</h5>
            <div className="space-y-1 text-[10px] text-blue-900">
              <div>
                <span className="font-semibold text-blue-800">Type:</span> {patient_request_type || "Not found"}
              </div>
              <div>
                <span className="font-semibold text-blue-800">Preferred Days:</span> {preferred_days.join(", ") || 'Not found'}
              </div>
              <div>
                <span className="font-semibold text-blue-800">Time Preferences:</span> {preferred_times.join(", ") || 'Not found'}
              </div>
              <div>
                <span className="font-semibold text-blue-800">Notes:</span> {patient_schedule_notes || "Not found"}
              </div>
            </div>
          </div>

          {future_appointment?.data &&
            <div className="bg-green-50 border border-green-100/30 rounded-lg mt-2 p-4 space-y-2">
              <div className='flex items-center gap-1 text-green-800'>
                <CheckCircle className="w-3 h-3 stroke-[3]" />
                <h5 className="text-[10px] font-bold tracking-wide">Admin Action: {startCase(patient_decision_type)}</h5>
              </div>

              <div className="space-y-1 text-[10px] text-green-800">
                <div>
                  <span className="font-semibold text-green-800">Date:</span> {formatDate(fAppointment_at, 'short')}
                </div>
                <div>
                  <span className="font-semibold text-green-800">Time:</span> {formatDate(fAppointment_at, 'twelveHour')}
                </div>
                <div>
                  <span className="font-semibold text-green-800">Provider:</span> {first_name}
                </div>
                <div>
                  <span className="font-semibold text-green-800">Duration:</span> {duration} min
                </div>
                <div>
                  <span className="font-semibold text-green-800">Notes:</span> {notes || "Not found"}
                </div>
                <div>
                  <span className="font-semibold text-green-800">Action Date:</span> {formatDate(created_at, 'slash')}
                </div>
              </div>
            </div>
          }

          <div className="bg-slate-50 border border-slate-100/50 rounded-lg p-4 space-y-1.5">
            <h5 className="text-[10px] font-bold text-secondary-900">Appointment Chain</h5>
            <p className="text-[10px] text-secondary-700">
              <span className="font-semibold">Origin:</span> Appointment #apt_{item?.id}
            </p>

            {futureAppointmentId && (
              <p className="text-[10px] text-secondary-700">
                <span className="font-semibold">Future:</span> Appointment #apt_{futureAppointmentId}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Item
